import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrompt1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"prompt, vibe-designing, box-sparkle"} maskId="square-filled-radius-0-stroke-1-IconPrompt1"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.25 10.25L7 11.5V12.5L10.25 13.75L11.5 17H12.5L13.75 13.75L17 12.5V11.5L13.75 10.25L12.5 7H11.5L10.25 10.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPrompt1;
